import React from 'react';
import { Grid } from '@doveit/bricks';
import LayoutWrapper from '../../layouts/layout-wrapper/LayoutWrapper';
import * as styles from './Hero.style';
import { BackgroundImage } from '../../types';

export interface HeroProps {
  cover: BackgroundImage,
  coverPosition?: 'top left' | 'top center' | 'top right' | 'left center',
  children: React.ReactNode,
}

const Hero: React.FC<HeroProps> = ({
  cover,
  coverPosition = 'top center',
  children,
}) => (
  <header css={styles.base}>
    <div
      css={styles.cover}
      $mobileCover={cover.SMALL}
      $desktopCover={cover.LARGE}
      $coverPosition={coverPosition}
    />
    <LayoutWrapper>
      <Grid>
        <Grid.Unit size={{ LG: 3 / 5 }}>
          <div css={styles.content}>
            {children}
          </div>
        </Grid.Unit>
      </Grid>
    </LayoutWrapper>
  </header>
);

export default Hero;
